/**
 * Een venster over het scherm heen, met een donkere achtergrond.
 *
 * Stond drie keer met de hand in de code (gelezen teksten, tekstvoorbeeld,
 * lesvoorbeeld). `breed` is de maximale breedte; `vanBoven` zet het venster
 * bovenaan in plaats van in het midden, voor lange inhoud.
 */
import React from 'react';

export function Venster({ children, breed = 1000, vanBoven = false }) {
  return (
    <div style={{ ...stijl.achtergrond, ...(vanBoven ? stijl.boven : {}) }}>
      <div style={{ ...stijl.venster, maxWidth: breed }}>{children}</div>
    </div>
  );
}

const stijl = {
  achtergrond: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)',
    zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  boven: { alignItems: 'flex-start', paddingTop: '40px', overflow: 'auto' },
  venster: { background: 'var(--wit)', borderRadius: 12, padding: 24, width: '90%', maxHeight: '90vh', overflow: 'auto' },
};
